"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.plugin = void 0;
var _plugin = _interopRequireDefault(require("tailwindcss/plugin"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var plugin = exports.plugin = (0, _plugin["default"])(function (_ref) {
  var _theme$base$, _theme, _theme$3xl$, _theme2, _theme$2xl$, _theme3, _theme$xl$, _theme4, _theme$lg$, _theme5, _theme$base$2, _theme6, _theme$base$3, _theme7, _theme$4xl$, _theme8, _theme$3xl$2, _theme9;
  var addBase = _ref.addBase,
    addComponents = _ref.addComponents,
    theme = _ref.theme;
  /**
   * BASE:
   * Adds base Sharp styles
   */
  addBase(_defineProperty({
    'html': {
      scrollBehavior: 'smooth',
      // Font smoothing (antialiasing)
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale'
    },
    'body': {
      color: theme('colors.gray.700'),
      fontWeight: theme('fontWeight.medium'),
      fontSize: theme('fontSize.base'),
      lineHeight: (_theme$base$ = (_theme = theme('fontSize')) === null || _theme === void 0 || (_theme = _theme.base) === null || _theme === void 0 ? void 0 : _theme[1]) !== null && _theme$base$ !== void 0 ? _theme$base$ : '1',
      '-webkit-tap-highlight-color': 'transparent'
    },
    'h1': {
      fontSize: theme('fontSize.3xl'),
      lineHeight: (_theme$3xl$ = (_theme2 = theme('fontSize')) === null || _theme2 === void 0 || (_theme2 = _theme2['3xl']) === null || _theme2 === void 0 ? void 0 : _theme2[1]) !== null && _theme$3xl$ !== void 0 ? _theme$3xl$ : '1',
      fontWeight: theme('fontWeight.medium')
    },
    'h2': {
      fontSize: theme('fontSize.2xl'),
      lineHeight: (_theme$2xl$ = (_theme3 = theme('fontSize')) === null || _theme3 === void 0 || (_theme3 = _theme3['2xl']) === null || _theme3 === void 0 ? void 0 : _theme3[1]) !== null && _theme$2xl$ !== void 0 ? _theme$2xl$ : '1',
      fontWeight: theme('fontWeight.medium')
    },
    'h3': {
      fontSize: theme('fontSize.xl'),
      lineHeight: (_theme$xl$ = (_theme4 = theme('fontSize')) === null || _theme4 === void 0 || (_theme4 = _theme4.xl) === null || _theme4 === void 0 ? void 0 : _theme4[1]) !== null && _theme$xl$ !== void 0 ? _theme$xl$ : '1',
      fontWeight: theme('fontWeight.medium')
    },
    'h4': {
      fontSize: theme('fontSize.lg'),
      lineHeight: (_theme$lg$ = (_theme5 = theme('fontSize')) === null || _theme5 === void 0 || (_theme5 = _theme5.lg) === null || _theme5 === void 0 ? void 0 : _theme5[1]) !== null && _theme$lg$ !== void 0 ? _theme$lg$ : '1',
      fontWeight: theme('fontWeight.semibold')
    },
    'h5': {
      fontSize: theme('fontSize.base'),
      lineHeight: (_theme$base$2 = (_theme6 = theme('fontSize')) === null || _theme6 === void 0 || (_theme6 = _theme6.base) === null || _theme6 === void 0 ? void 0 : _theme6[1]) !== null && _theme$base$2 !== void 0 ? _theme$base$2 : '1',
      fontWeight: theme('fontWeight.semibold')
    },
    'h6': {
      fontSize: theme('fontSize.base'),
      lineHeight: (_theme$base$3 = (_theme7 = theme('fontSize')) === null || _theme7 === void 0 || (_theme7 = _theme7.base) === null || _theme7 === void 0 ? void 0 : _theme7[1]) !== null && _theme$base$3 !== void 0 ? _theme$base$3 : '1',
      fontWeight: theme('fontWeight.semibold')
    },
    'strong, b': {
      fontWeight: theme('fontWeight.semibold')
    },
    'ol': {
      listStyle: 'decimal'
    }
  }, "@media (min-width: ".concat(theme('screens.lg'), ")"), {
    'h1': {
      fontSize: theme('fontSize.4xl'),
      lineHeight: (_theme$4xl$ = (_theme8 = theme('fontSize')) === null || _theme8 === void 0 || (_theme8 = _theme8['4xl']) === null || _theme8 === void 0 ? void 0 : _theme8[1]) !== null && _theme$4xl$ !== void 0 ? _theme$4xl$ : '1'
    },
    'h2': {
      fontSize: theme('fontSize.3xl'),
      lineHeight: (_theme$3xl$2 = (_theme9 = theme('fontSize')) === null || _theme9 === void 0 || (_theme9 = _theme9['3xl']) === null || _theme9 === void 0 ? void 0 : _theme9[1]) !== null && _theme$3xl$2 !== void 0 ? _theme$3xl$2 : '1'
    }
  }));

  /**
   * CONTAINER:
   * Remove horizontal padding on nested containers,
   * used when dynamically rendering blocks in blocks.
   */
  addComponents({
    '.container .container': {
      paddingLeft: theme('spacing.0'),
      paddingRight: theme('spacing.0')
    }
  });

  /**
   * RICH TEXT:
   * content not control from Rich Text Editors
   * like Contentful RichText, Markdown to JSX, etc.
   *
   * Requires that embedded entries/blocks are styled
   * with the CSS class of `.sscl-rich-text`.
   *
   * Optional classes
   * `.scl-rich-text-list-center` - Centers a list ul/ol
   * `.scl-rich-text-list-column-2` - Makes lists two columns at lg breakpoint
   * `.scl-rich-text-list-column-3` - Makes lists three columns at lg breakpoint
   */
  addComponents({
    '.scl-rich-text': _defineProperty({
      /**
       * Base
       */
      '& ::marker': {
        fontWeight: 'inherit'
      },
      /**
       * Spacing
       * NOTE: Order matters
       */

      /* Spacing Rule #1: First child no spacing
       * using named elements for specificity
       */
      '& > p:first-child': {
        marginTop: theme('spacing.0')
      },
      '& > ul:first-child, > ol:first-child': {
        marginTop: theme('spacing.0')
      },
      '& > h1:first-child, > h2:first-child, > h3:first-child, > h4:first-child, > h5:first-child, > h6:first-child, > hr:first-child, > .scl-rich-text-block:first-child': {
        marginTop: theme('spacing.0')
      },
      '& > hr': {
        marginTop: theme('spacing.0')
      },
      '& > .scl-rich-text-block': {
        marginTop: theme('spacing.0')
      },
      /* Spacing Rule #2: List follows anything */
      '& > * + ul, > * + ol': {
        marginTop: theme('spacing.7') /* 28px */
      },
      /* Spacing Rule #2.1: List follows paragraph */
      '& > p + ul, > p + ol': {
        marginTop: theme('spacing.4') /* 16px */
      },
      /* Spacing Rule #3: Heading following anything; also see large breakpoint overrides */
      '& > * + h1, > * + h2, > * + h3, > * + h4, > * + h5, > * + h6': {
        marginTop: theme('spacing.12') /* 48px */
      },
      /* Spacing Rule #4: Heading following a List; also see large breakpoint overrides */
      '& > ul + h1, > ul + h2, > ul + h3, > ul + h4, > ul + h5, > ul + h6, > ol + h1, > ol + h2, > ol + h3, > ol + h4, > ol + h5, > ol + h6': {
        marginTop: theme('spacing.9') /* 36px */
      },
      /* Spacing Rule #5: hr following anything; also see large breakpoint overrides */
      '& > * + hr': {
        marginTop: theme('spacing.12') /* 48px */
      },
      /* Spacing Rule #6: hr following List; also see large breakpoint overrides */
      '& > ul + hr, > ol + hr': {
        marginTop: theme('spacing.9') /* 36px */
      },
      /* Spacing Rule #7: Block following anything */
      '& > * + .scl-rich-text-block': {
        marginTop: theme('spacing.8') /* 32px */
      },
      /* Spacing Rule #8: Block following List */
      '& > ul + .scl-rich-text-block, > ol + .scl-rich-text-block': {
        marginTop: theme('spacing.5') /* 20px */
      },
      /* Spacing Rule #9: Paragrah following anything */
      '& > * + p': {
        marginTop: theme('spacing.7') /* 28px */
      },
      /* Spacing Rule #10: Paragrah following List */
      '& > ul + p, > ol + p': {
        marginTop: theme('spacing.4') /* 16px */
      },
      /* Spacing Rule #11 Paragraph follows an embedded entry */
      '& > .scl-rich-text-block + p': {
        marginTop: theme('spacing.8') /* 32px */
      },
      /* Spacing Rule #12 Paragraph follows an HR; also see large breakpoint overrides */
      '& > hr + p': {
        marginTop: theme('spacing.12') /* 48px */
      },
      /**
       * Lists
       */

      /* List spacing */
      '& ul, ol': {
        marginLeft: theme('spacing.5') /* 20px */
      },
      /* List styles type (3 levels deep) */
      '& ul': {
        listStyleType: theme('listStyleType.disc'),
        '& ul': {
          listStyleType: 'circle',
          '& ul': {
            listStyleType: 'square'
          }
        }
      },
      '& ol': {
        listStyleType: theme('listStyleType.decimal'),
        '& ol': {
          listStyleType: 'lower-alpha',
          '& ol': {
            listStyleType: 'lower-roman'
          }
        }
      },
      /* List alignment */
      '&.scl-rich-text-list-center': {
        '& > ul, > ol': {
          display: 'inline-block',
          textAlign: 'left'
        }
      },
      /* List item */
      '& li': {
        paddingBottom: theme('spacing.3'),
        /* 12px */
        breakInside: 'avoid-column'
      },
      '& li > p': {
        display: 'inline'
      }
    }, "@media (min-width: ".concat(theme('screens.lg'), ")"), {
      /* Spacing Rule #3: Heading following anything */
      '& > * + h1, > * + h2, > * + h3, > * + h4, > * + h5, > * + h6': {
        marginTop: theme('spacing.15') /* 60px */
      },
      /* Spacing Rule #4: Heading following List */
      '& > ul + h1, > ul + h2, > ul + h3, > ul + h4, > ul + h5, > ul + h6, > ol + h1, > ol + h2, > ol + h3, > ol + h4, > ol + h5, > ol + h6': {
        marginTop: theme('spacing.12') /* 48px */
      },
      /* Spacing Rule #5: HR following anything */
      '& > * + hr': {
        marginTop: theme('spacing.15') /* 60px */
      },
      /* Spacing Rule #6: HR following List */
      '& > ul + hr, > ol + hr': {
        marginTop: theme('spacing.12') /* 48px */
      },
      /* Spacing Rule #12: Paragraph follows an HR */
      '& > hr + p': {
        marginTop: theme('spacing.15') /* 60px */
      },
      /* List columns */
      '&.scl-rich-text-list-column-2': {
        '& > ul, > ol': {
          columns: theme('columns.2'),
          gap: theme('spacing.15') /* 60px */
        }
      },
      '&.scl-rich-text-list-column-3': {
        '& > ul, > ol': {
          columns: theme('columns.3'),
          gap: theme('spacing.15') /* 60px */
        }
      }
    })
  });
});